/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeMenuItemSpace } from "../../d-menu-item-space";
import { DThemeDarkLayoutSpace } from "./d-theme-dark-layout-space";

export class DThemeDarkMenuItemSpace extends DThemeDarkLayoutSpace implements DThemeMenuItemSpace {}
